(function() {
    'use strict';

    var map, markerCluster, bounds;
    var markers = [];
    var template = Handlebars.compile($('#marker-content-template').html());
    var queryPlz = QueryString.plz;
    var queryKm = QueryString.km;
    var queryUrlSearch = QueryString.urlSearch;
    /*if (window.localStorage) {
        if (typeof localStorage.getItem("localStoragePlz") !== 'undefined' && localStorage.getItem("localStoragePlz") !== null) {
            localStorage.setItem('localStoragePlz', queryPlz);
            localStorage.setItem('localStorageKm', queryKm);
            $('#umkreis').val(localStorage.getItem('localStorageKm'));
            $('#plz').val(localStorage.getItem('localStoragePlz'));
        }
    } */
    function initialize() {
        var center = { lat: 51.165691, lng: 10.451526000000058 };
        map = new google.maps.Map(document.getElementById('map'), {
            zoom: 7,
            center: center,
            mapTypeControl: false,
            scaleControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            maxZoom: 15,
            minZoom: 3,
            styles:  [{"featureType": "all", "stylers": [{"saturation": -100},{"visibility": "on"}]}]
        });

        clearLocations();
        bounds = new google.maps.LatLngBounds();
        getLocations();

        google.maps.event.addListenerOnce(map, 'tilesloaded', function(){
            if( typeof queryUrlSearch != 'undefined' && queryUrlSearch == 1) {
                if (window.localStorage) {
                    localStorage.setItem('localStoragePlz', queryPlz);
                    localStorage.setItem('localStorageKm', queryKm);
                    $('#umkreis').val(localStorage.getItem('localStorageKm'));
                    $('#plz').val(localStorage.getItem('localStoragePlz'));
                } 
                getLocations_by_zip(queryPlz, queryKm);
            }
        });
    }

    function getLocations() {

        $.ajax({
            url: GUTACHTER_GET.root,
            dataType: 'json',
            success: function(data) {

                $.each(data, function(i, item) {
                    var marker = new google.maps.Marker({
                        position: new google.maps.LatLng(item.latitude, item.longitude),
                        id: item.id,
                        map: map,
                        icon: templateUrl + '/public/img/icons/icon_map_marker_blue.png',
                    });
                    markers.push(marker);
                    var infoWindow = new SnazzyInfoWindow({
                        marker: marker,
                        content: 'Snazzy!',
                        wrapperClass: 'map__marker-popup',
                        closeWhenOthersOpen: true,
                        callbacks: {
                            beforeOpen: function() {
                                this.setContent('loading...');
                            },
                            afterOpen: function() {
                                var me = this;
                                var vars = { tel: item.tel, email: item.email };
                                me.setContent(template(vars));
                            },
                            afterClose: function() {}
                        }
                    });
                });

            }
        });
    } // END getLocations

    function getLocations_by_zip(plz, umkreis) {
        var data = {
            umkreis: umkreis,
            plz: plz
        };
        var position;

        $.ajax({
            method: "POST",
            url: GUTACHTER_GET.get_locations_by_zip,
            data: data,
            success: function(data) {
                clearLocations();
                $.each(data, function(i, item) {
                    //console.log(item[0].latitude);
                    position = new google.maps.LatLng( item[0].latitude, item[0].longitude);
                    var marker = new google.maps.Marker({
                        position: position,
                        id: item.id,
                        map: map,
                        icon: templateUrl + '/public/img/icons/icon_map_marker_blue.png',
                    });
                    bounds.extend( position );
                    map.fitBounds(bounds); 
                    markers.push(marker);
                    google.maps.event.trigger(map, 'resize');
                    var infoWindow = new SnazzyInfoWindow({
                        marker: marker,
                        content: 'Snazzy!',
                        wrapperClass: 'map__marker-popup',
                        closeWhenOthersOpen: true,
                        callbacks: {
                            beforeOpen: function() {
                                this.setContent('loading...');
                            },
                            afterOpen: function() {
                                var me = this;
                                var vars = { tel: item[0].tel, email: item[0].email };
                                me.setContent(template(vars));
                            },
                            afterClose: function() {}
                        }
                    });
                    google.maps.event.addListenerOnce(map, 'bounds_changed', function(event) {
                      if (this.getZoom() > 10) {
                        this.setZoom(10);
                      }
                    });
                });

            },
            error: function(data) {
                //console.log(data);
            }
        });
    } // END getLocations_by_zip

    function clearLocations() {
        for (var i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
        markers.length = 0;
    } // END clearLocations

if ($('body').is('.page-template-page-map')) {
    $(document).ready(function() {
        initialize();
        $('.select-umkreis').select2({
            placeholder: 'Umkreis auswählen',
            width: '100%',
            minimumResultsForSearch: -1
        });
        $('b[role="presentation"]').hide();
        $('.select2-selection__arrow').append('<i class="fa fa-lg fa-angle-down"></i>');


        $('#find_gutachter').on('submit', function(e) {
            e.preventDefault();
            bounds = new google.maps.LatLngBounds();
            var umkreis_val = $('#umkreis').val();
            var plz_val = $('#plz').val();
            getLocations_by_zip(plz_val, umkreis_val);
        }); 

    });
}
})();